module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_6.98b9ff41.png";